import { AppUtils } from '../core/utils/app-utils';
import { CoreToolbox } from '../core/utils/core-toolbox';

export class PrintServiceClient {
	public static openPdfAndPrint(response: any): void {

		if (AppUtils.isMobileApp) {
			// Handle for case mobile print, convert pdf to base64 string then sent to native code
			return PrintServiceClient.printOnMobile(response) as any;
		}
		this.removePrintElements();
		const blob = new Blob([response], {
			type: "application/pdf"
		});
		const blobUrl = URL.createObjectURL(blob);
		const iframe = document.createElement("iframe");
		iframe.className = "pos-popup-print";
		iframe.style.display = "none";
		iframe.src = blobUrl;
		document.body.appendChild(iframe);
		setTimeout(() => {
			iframe.contentWindow && iframe.contentWindow.print();
		}, 500);
	}

	private static printOnMobile(response: any) {
		const reader = new FileReader();
		reader.onloadend = () => {
			const base64data = reader.result as string;
			CoreToolbox.appUpdateService.printBill({
				bill_content: base64data
			}) as any;
		};
		reader.readAsDataURL(new Blob([response], {
			type: "application/pdf"
		}));
	}

	private static removePrintElements(): void {
		this.removeElements(document.querySelectorAll(".pos-popup-print"));
	}

	private static removeElements = elms => elms.forEach(el => el.remove());
}
